import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HeaderContainer = styled.header`
  background-color: #f0f9ff;
  padding: 10px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const TopBar = styled.div`
  background-color: #00b8d4;
  color: white;
  padding: 8px 0;
  text-align: center;
  font-size: 14px;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Logo = styled.div`
  img {
    height: 60px;
  }
`;

const Navigation = styled.nav`
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const NavItem = styled.li`
  margin: 0 15px;
`;

const NavLink = styled(Link)`
  color: #6a1b9a;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  transition: color 0.3s;
  
  &:hover {
    color: #9c27b0;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6a1b9a;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const ContactButton = styled(Link)`
  background-color: #ff6f00;
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #ff9100;
  }
`;

const Header = () => {
  return (
    <>
      <TopBar>
        <div>Seg a Sex: 8h às 17h | R. Exemplo, 123 - Bairro, Cidade - Estado</div>
      </TopBar>
      <HeaderContainer>
        <HeaderContent>
          <Logo>
            <Link to="/">
              <img src="/logo-placeholder.png" alt="Ateliê Dentinhos de Leite" />
            </Link>
          </Logo>
          
          <Navigation>
            <NavList>
              <NavItem><NavLink to="/especialidades">Especialidades</NavLink></NavItem>
              <NavItem><NavLink to="/estrutura">Estrutura</NavLink></NavItem>
              <NavItem><NavLink to="/depoimentos">Depoimentos</NavLink></NavItem>
              <NavItem><NavLink to="/quem-somos">Quem Somos</NavLink></NavItem>
              <NavItem><NavLink to="/nossa-equipe">Nossa Equipe</NavLink></NavItem>
              <NavItem><NavLink to="/contato">Contato</NavLink></NavItem>
            </NavList>
          </Navigation>
          
          <ContactButton to="/agendar">Agendar consulta</ContactButton>
          
          <MobileMenuButton aria-label="Menu">
            ☰
          </MobileMenuButton>
        </HeaderContent>
      </HeaderContainer>
    </>
  );
};

export default Header;
